<template>
  <div>
    <!-- Back Button -->
    <v-row style="margin-bottom: 20px">
      <router-link style="margin-right: 20px" :to="{ name: 'StatisticsCrawlers' }">zurück</router-link>
      <v-icon size="40px">$pacman</v-icon>
      <div style="font-size: 30px; margin-left: 20px">Crawlers</div>
    </v-row>
    <crawler-stats></crawler-stats>
  </div>
</template>

<script>
import CrawlerStats from '@/components/statistics/Crawler.vue'

export default {
  components: {
    CrawlerStats
  }
}
</script>
